import script from "./DisplayLandingPageView.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayLandingPageView.vue?vue&type=script&setup=true&lang=js"

import "./DisplayLandingPageView.vue?vue&type=style&index=0&id=9eb21bd0&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eb21bd0"]])

export default __exports__